import { GalleryLayout14 } from '@components/gallery/components/gallery-layout-14/model';
import { PromotionDocument } from '@services/elastic-search/models';
import { ElasticSearchResponse } from '@services/elastic-search/models/elastic-search-response';
import { LogsService } from '@services/logs';

export const storePromotionSerializer = (
  response: ElasticSearchResponse<PromotionDocument>
): GalleryLayout14 | undefined => {
  const promotionJson = response.hits.hits[0]?._source?.promotion?.[0];

  if (!promotionJson) {
    return undefined;
  }

  try {
    return JSON.parse(promotionJson) as GalleryLayout14;
  } catch (error) {
    LogsService.error(
      'storePromotionSerializer',
      'Error during JSON conversion of the promotion',
      error,
      promotionJson
    );
    return undefined;
  }
};
